<template>
  <v-container fluid class="my-v-container">
    <v-app-bar app elevation="0" color="var(--bg-color)">
      <sea-plus-nav-icon></sea-plus-nav-icon>
      <v-spacer></v-spacer>
      <accumulate-nav-button></accumulate-nav-button>
    </v-app-bar>
    <v-card width="600" class="my-v-card" v-if="user">
      <v-card-title>会員様情報</v-card-title>
      <v-card-subtitle>ご登録情報</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col>
            {{ user.displayName }} <span v-if="user.email">({{ user.email }})</span><br />
            <a
              href="/"
              @click="
                createBillingPortalSession()
                $event.preventDefault()
              "
            >
              ご登録情報を変更する
            </a>
            <v-progress-circular
              v-if="isProcessing"
              indeterminate
              color="primary"
              :width="2"
              :size="20"
              class="ml-2"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-subtitle> 現在のプラン </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col>
            {{ planLabel }}
          </v-col>
        </v-row>
      </v-card-text>

      <!-- <div v-if="stripeSubscription && user.plan !== Plan.ONE_TIME_PURCHASE">
        <name-value-view name="定期購入" :value="stripeSubscription.status" />
        <name-value-view name="プラン（配送サイクル）" :value="`${stripeSubscription.plan.interval_count}日`" />
        <name-value-view name="定期購入開始日" :value="formatDateFromSeconds(stripeSubscription.created)" />
        <name-value-view
          name="次回配送予定日"
          :value="
            stripeSubscription.status === 'active' && !stripeSubscription.cancel_at_period_end
              ? formatDateFromSeconds(stripeSubscription.current_period_end)
              : ''
          "
        />
      </div> -->

      <!-- <v-card-subtitle v-if="stripeSubscription"> 次回のお支払い </v-card-subtitle>
      <v-card-text v-if="stripeSubscription">
        <v-row>
          <v-col>
            {{
              stripeSubscription.status === 'active' && !stripeSubscription.cancel_at_period_end
                ? formatDateFromSeconds(stripeSubscription.current_period_end)
                : ''
            }}
          </v-col>
        </v-row>
      </v-card-text> -->

      <v-card-subtitle> お支払い方法 </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col> {{ paymentMethodLabel }} </v-col>
        </v-row>
      </v-card-text>

      <v-card-title> メールマガジン </v-card-title>
      <v-card-text>
        <v-row v-if="user">
          <v-col>
            <v-checkbox
              v-model="user.isNotificationEnabled"
              label="SEA+の最新情報やお得な情報、メルマガ限定のキャンペーン情報などを受け取る。"
              @change="handleChangeNotificationEnabled($event)"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <!-- <v-card-actions>
        <v-row>
          <v-col>
            <v-btn color="primary" :disabled="isProcessing" @click="createBillingPortalSession">
              <v-progress-circular
                v-if="isProcessing"
                indeterminate
                color="primary"
                :width="2"
                :size="20"
              ></v-progress-circular>
              {{ isProcessing ? null : '定期購入を確認する' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions> -->
      <v-card-title> お知らせ </v-card-title>
      <v-card class="my-v-card">
        <v-card-subtitle>【配送につきまして】 </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col>
              商品は【郵便受け投函】にてお送りさせて頂きます。配達日時指定、代引きでのお支払いは不可となりますので改めご了承ください。
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-subtitle>【納品書につきまして】 </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col> 環境保全活動の一環として納品書は同梱しておりませんのでご了承ください。 </v-col>
          </v-row>
        </v-card-text>
        <v-card-subtitle>【領収証につきまして】 </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col>
              領収書をご希望の方は hello@seaplus.style か、<a href="https://www.seaplus.style/contact">Contact</a
              >よりお問合せください。
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-subtitle>【返品・交換対応につきまして】 </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col>
              SEA+はご購入後、実際に使用してみて何かおかしいと感じた場合にご連絡をいただけましたら商品代金を返金、またはご交換にてご対応させて頂きます。詳しくは
              <a href="https://www.seaplus.style/nscta">こちら</a> を御確認ください
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-subtitle>【解約について】 </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col> 発送予定日の10日前までにお申し出ください。 </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import { createBillingPortalSession } from '@/services/functions'
import { createNamespacedHelpers } from 'vuex'
import SeaPlusNavIcon from '@/components/SeaPlusNavIcon.vue'
import AccumulateNavButton from '@/components/buttons/AccumulateNavButton.vue'
import { format } from 'date-fns'
import { firebaseAuth } from '@/services/firebase'
import { PaymentMethod, Plan, userCollection } from '@shared/collections/user.collection'
import { stripeSubscriptionCollection } from '@shared/collections/stripeSubscription.collection'
import { isSubscriptionActive } from '@/helpers/subscription'
import { subscriptionCollection } from '@shared/collections/subscription.collection'

const userStore = createNamespacedHelpers('user')

export default {
  components: {
    SeaPlusNavIcon,
    AccumulateNavButton
  },
  data: () => ({
    stripeSubscription: null,
    subscription: null,
    isProcessing: false,
    Plan
  }),
  computed: {
    ...userStore.mapState(['userId', 'user']),
    planLabel() {
      /** @type {{user: import('@shared/collections/user.collection').UserModel}} */
      const { user } = this
      if (user && user.plan) {
        return Plan.getName(user.plan)
      }

      return ''
    },
    paymentMethodLabel() {
      /** @type {{user: import('@shared/collections/user.collection').UserModel}} */
      const { user } = this
      if (user && user.paymentMethod) {
        return PaymentMethod.getLabel(user.paymentMethod)
      }

      return ''
    }
  },
  methods: {
    async loadSubscription() {
      const { userId } = this
      if (userId) {
        this.subscription = await subscriptionCollection.findByUserId(userId)
      }
    },
    async loadStripeSubscription() {
      /** @type {{user: import('@shared/collections/user.collection').UserModel}} */
      const { user } = this
      if (
        user &&
        user.paymentMethod == PaymentMethod.CREDIT_CARD &&
        user.stripeSubscriptionId &&
        !this.stripeSubscription
      ) {
        this.stripeSubscription = await stripeSubscriptionCollection.find(user.stripeSubscriptionId)
      }
    },
    checkStripeSubscriptionStatus() {
      if (this.$route.query.checkout) {
        console.log('Skip checkStripeSubscriptionStatus')
        return
      }

      /** @type {{user: import('@shared/collections/user.collection').UserModel}} */
      const { user } = this

      if (
        user &&
        ![
          '/select-plan',
          '/sign-in',
          '/sign-in-with-email',
          '/sign-up',
          '/sign-up-with-email',
          '/select-payment-method'
        ].includes(this.$route.path)
      ) {
        if (!isSubscriptionActive(user)) {
          this.$router.replace('/select-plan')
        }
      }
    },
    async createBillingPortalSession() {
      this.isProcessing = true
      const {
        data: { billingPortalSession }
      } = await createBillingPortalSession({
        returnUrl: window.location.href
      })
      this.isProcessing = false
      if (billingPortalSession && billingPortalSession.url) {
        window.location.href = billingPortalSession.url
      }
    },
    formatDateFromSeconds(seconds) {
      return this.formatDate(new Date(seconds * 1000))
    },
    formatDate(date) {
      return format(date, 'yyyy-MM-dd')
    },
    changeShippingInfo() {
      this.$router.push('/change-shipping-info')
    },
    async handleChangeNotificationEnabled(isEnabled) {
      const { userId } = this
      if (userId) {
        await userCollection.update(userId, {
          isNotificationEnabled: isEnabled
        })
      }
    }
  },
  watch: {
    userId() {
      this.loadSubscription()
      this.loadStripeSubscription()
      this.checkStripeSubscriptionStatus()
    }
  },
  mounted() {
    firebaseAuth.onAuthStateChanged((user) => {
      if (!user) {
        this.$router.replace('/select-plan')
      }
    })

    this.loadSubscription()
    this.loadStripeSubscription()
    this.checkStripeSubscriptionStatus()
  }
}
</script>

<style scoped>
.v-card__subtitle {
  padding-bottom: 0 !important;
}
</style>
